import { useState } from 'react'
import { INITIAL_FORM_DATA } from '../leagueFormConstants'

export default function useLeagueFormState() {
  const [formData, setFormData] = useState(INITIAL_FORM_DATA)
  const [errors, setErrors] = useState({})

  const clearFieldError = (fieldName) => {
    setErrors((prev) => {
      if (!prev[fieldName]) return prev
      const next = { ...prev }
      delete next[fieldName]
      return next
    })
  }

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }))
    clearFieldError(name)
  }

  const handleDateSectionChange = (fields) => {
    setFormData((prev) => ({
      ...prev,
      ...fields,
    }))

    setErrors((prev) => {
      const next = { ...prev }
      Object.keys(fields).forEach((field) => {
        if (fields[field]) {
          delete next[field]
        }
      })
      return next
    })
  }

  return {
    formData,
    setFormData,
    errors,
    setErrors,
    handleInputChange,
    handleDateSectionChange,
  }
}
